export const textLinks = [
  { id: 1, link: '/home', title: 'Home' },
  { id: 2, link: '/profile', title: 'Profile' },
  { id: 3, link: '/products', title: 'Products' },
  { id: 4, link: '/diary', title: 'Diary' },
  { id: 5, link: '/statistics', title: 'Statistics' },
];
